import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { Loader2, AlertTriangle, Package } from 'lucide-react'
import { api } from '@/lib/api'

export function ScanPage() {
  const { tagCode } = useParams<{ tagCode: string }>()
  const navigate = useNavigate()
  const [error, setError] = useState('')

  useEffect(() => {
    if (!tagCode) return

    api.get(`/scan/${tagCode}`)
      .then(({ data }) => {
        navigate(`/assets/${data.assetId}`, { replace: true })
      })
      .catch(() => {
        setError('This QR code could not be resolved to an asset. It may have been deactivated or removed.')
      })
  }, [tagCode, navigate])

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="text-center max-w-sm">
          <AlertTriangle className="w-12 h-12 text-red-400 mx-auto mb-4" />
          <h1 className="text-lg font-semibold text-navy-800 mb-2">Asset Not Found</h1>
          <p className="text-sm text-gray-500 mb-6">{error}</p>
          <a href="/login" className="btn-primary inline-flex">
            Go to EstateKey
          </a>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="text-center">
        <Package className="w-10 h-10 text-navy-400 mx-auto mb-3 animate-pulse" />
        <Loader2 className="w-6 h-6 animate-spin text-navy-800 mx-auto mb-3" />
        <p className="text-sm text-gray-500">Looking up asset...</p>
      </div>
    </div>
  )
}
